<div class="planning-draft-job-change-row" [ngClass]="{'is-unavailable': isUnavailable}">
  <div class="tr layout-row layout-align-start-center" (click)="toggleExpand()">

    <div class="td layout-row layout-align-start-center flex-5">
      <app-bringoz-checkbox [isDisabled]="isUnavailable || isSelectionLocked"
                            [isChecked]="isSelected && !isUnavailable"
                            (clickEvent)="toggleSelect();$event.stopPropagation()">
      </app-bringoz-checkbox>
      <span class="availability-dot margin-left-10" [ngClass]="isUnavailable ? 'unavailable' : 'available'"
            [ngbTooltip]="(isUnavailable ? 'UNAVAILABLE' : 'AVAILABLE') | translate" openDelay="300" triggers="hover">
      </span>
    </div>

    <div class="td flex-25 text-ellipsis" [ngbTooltip]="change.orderExternalId || change.orderId || change.draftJobId" openDelay="300" triggers="hover">
      {{ change.orderExternalId || change.orderId || change.draftJobId || '-' }}
    </div>

    <div class="td flex-20">
      <app-bringoz-items-list-display [items]="change.changed?.changedFields"
                                      [maxItems]="1"
                                      prefix="PLANNING_DRAFT_JOB_CHANGES_FIELDS">
      </app-bringoz-items-list-display>
    </div>

    <div class="td flex-15 text-ellipsis" [ngbTooltip]="change.routeId" openDelay="300" triggers="hover">
      {{ change.routeId || '-' }}
    </div>

    <div class="td flex-25 text-ellipsis">
      @if (change.reason) {
        <span>{{ 'PLANNING_DRAFT_JOB_CHANGES_REASONS.' + change.reason | translate }}</span>
      } @else {
        <span>---</span>
      }
      @if (change.status === statuses.FAILED) {
        <span class="br-caption-2 failed-badge margin-left-5">
          {{ 'PLANNING_DRAFT_JOB_CHANGES_STATUSES.' + change.status | translate }}
          @if (change.failureReason) {
            &middot; {{ 'PLANNING_DRAFT_JOB_CHANGES_REASONS.' + change.failureReason | translate }}
          }
        </span>
      }
      @if (recoveryHintKey) {
        <div class="br-body-3 recovery-hint">{{ recoveryHintKey | translate }}</div>
      }
    </div>

    <div class="td flex-10 layout-row layout-align-end-center">
      <bringoz-icon [iconName]="isExpanded ? 'arrow-up' : 'arrow-down'" classSize="sm"></bringoz-icon>
    </div>
  </div>

  @if (isExpanded) {
    <div class="expanded-diff">
      <app-planning-draft-job-change-diff [change]="change"></app-planning-draft-job-change-diff>
    </div>
  }
</div>
